/**
 * Dispatches a custom event for communicating with React components
 * @param eventName - Custom event name
 * @param detail - Dictionary of data to provide with the event
 */
export function dispatch<T>(eventName: string, detail?: T): void {
  // Only run on the client
  if (typeof document === 'undefined') {
    return;
  }

  eventName = 'edureact_' + eventName;

  let event;
  try {
    event = new CustomEvent<T>(eventName, {detail});
  } catch (e) {
    // IE doesn't support CustomEvent as a constructor, so need to use this legacy method as a fallback
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(event, false, true, detail);
  }

  console.log(eventName, detail);
  document.dispatchEvent(event);
}

interface ListenCallback<T> {
  (detail?: T): void;
}

interface ListenRemover {
  (): void;
}

/**
 * Listens for custom events
 * @param eventName - Name of custom event to listen for
 * @param callback
 */
export function listen<T>(eventName: string, callback: ListenCallback<T>): ListenRemover {
  // Only run on the client
  if (typeof document === 'undefined') {
    return function(): void {};
  }

  const name = `edureact_${eventName}`;

  const handler = (event): void => {
    callback(event.detail);
  };

  document.addEventListener(name, handler);
  return function(): void {
    document.removeEventListener(name, handler);
  };
}
